"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROLE_INFO = exports.DEFAULT_COMPANY_ID = void 0;
exports.resolveRoleInfo = resolveRoleInfo;
exports.DEFAULT_COMPANY_ID = 'default';
exports.DEFAULT_ROLE_INFO = {
    role: null,
    companyId: exports.DEFAULT_COMPANY_ID,
    isSysAdmin: false,
    isAdmin: false,
    isEditor: false,
    canManageUsers: false,
    canSeeAllResources: false,
};
function resolveRoleInfo(userData, companyId = exports.DEFAULT_COMPANY_ID) {
    if (!userData)
        return { ...exports.DEFAULT_ROLE_INFO, companyId };
    const isSysAdmin = !!userData.isSysAdmin;
    const role = userData.companies?.[companyId]?.role ?? null;
    const isAdmin = isSysAdmin || role === 'admin';
    return {
        role: isSysAdmin ? 'sysadmin' : role,
        companyId,
        isSysAdmin,
        isAdmin,
        isEditor: role === 'editor',
        canManageUsers: isAdmin,
        canSeeAllResources: isAdmin,
        canDeleteResources: isSysAdmin || userData.companies?.[companyId]?.canDeleteResources !== false,
        canEditAllClients: role !== null && userData.companies?.[companyId]?.canEditAllClients === true,
    };
}
